export const iconFontAwesomeMapsFireFlameCurved = (
	<i className="fa-solid fa-fire-flame-curved"></i>
);
